module.exports = __webpack_public_path__ + "img/_icon-locations.533c604a.svg";